"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentList = exports.deleteQuo = exports.getOneQuo = exports.getQuoList = exports.getInsertBySet = exports.getInstalledConfList = exports.getAddressDetail = exports.getAddressDelete = exports.getAddressModify = exports.getAddressInsert = exports.getAddressList = exports.getCountryList = exports.getContact = exports.addComment = exports.completeOrder = exports.copyOrder = exports.cancelOrder = exports.orderDetail = exports.orderList = exports.submitOrder = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 提交订单
exports.submitOrder = (params) => http().post('/salescontracts/insert', params);
// 订单列表
exports.orderList = (params) => http().post('/salescontracts/getList', params);
// 订单详情
exports.orderDetail = (params) => http().post('/salescontracts/getOne', params);
// 取消订单
exports.cancelOrder = (params) => http().post('/salescontracts/delete', params);
// 复制订单
exports.copyOrder = (params) => http().post('/salescontracts/copy', params);
// 完成订单
exports.completeOrder = (params) => http().post('/salescontracts/updateStatus', params);
// 添加评论
exports.addComment = (params) => http().post('/salescontracts/insertcomment', params);
// 业务员联系方式
exports.getContact = (params) => http().post('/adminUser/getContact', params);
// 贸易国家列表
exports.getCountryList = (params) => http().post('/country/list', {});
// 收件人地址列表
exports.getAddressList = (params) => http().post('/customersAddress/getList', params);
// 新增地址
exports.getAddressInsert = (params) => http().post('/customersAddress/insert', params);
// 修改地址
exports.getAddressModify = (params) => http().post('/customersAddress/modify', params);
//  删除地址
exports.getAddressDelete = (params) => http().post('/customersAddress/delete', params);
//  查询地址详情
exports.getAddressDetail = (params) => http().post('/customersAddress/getOne', params);
//  自主装机获取低中高端产品/替换产品
exports.getInstalledConfList = (params) => http().post('/installedConf/list', params);
//  自主装机管理下单
exports.getInsertBySet = (params) => http().post('/salescontracts/insertBySet', params);
//  获取我的报价单列表
exports.getQuoList = (params) => http().post('/salescontracts/getQuoList', params);
//  获取报价单详情
exports.getOneQuo = (params) => http().post('/salescontracts/getOneQuo', params);
// 取消报价单
exports.deleteQuo = (params) => http().post('/salescontracts/deleteQuo', params);
// 获取价格条款和付款方式
exports.paymentList = (params) => http().post('/dicPayment/list', params);
